import DataGridComponent from 'components/DataGrid/DataGridComponent';
import React, { useState } from 'react';
import { announcementsHeaderData, announcementsApiEndpoint, announcementsSearchState, announcementsInitialState } from './Announcements.data';
import AnnouncementsForm from './AnnouncementsForm';

const addTitle = 'Add New Announcement';
const editTitle = 'Edit Announcement';

const Announcements = () => {
    const apiEndpoints = announcementsApiEndpoint;
    const [showModal, setShowModal] = useState(false);
    const [editRowData, setEditRowData] = useState(announcementsInitialState);
    const [modalTitle, setModalTitle] = useState(addTitle);
    const [refreshDatagrid, setRefreshDatagrid] = useState(false);
    const [rowDetails, setRowDetails] = useState({
        columnName: 'RowId',
        rowNumber: ''
    });

    const handleEditRecord = (obj) => {
        const rowData = obj.row;
        setModalTitle(editTitle);
        setShowModal(true);
        setEditRowData((prev) => ({
            ...prev,
            ...rowData
        }));
    };

    const handleAddRecord = () => {
        setEditRowData(announcementsInitialState);
        setModalTitle(addTitle);
        setShowModal(true);
    };

    const handleModalClose = () => {
        setShowModal(false);
    };

    const handleRecordSubmit = (newId) => {
        setRefreshDatagrid((prev) => !prev);
        setRowDetails((prev) => ({ ...prev, rowNumber: newId }));
    };

    return (
        <>
            <DataGridComponent
                headerData={announcementsHeaderData}
                apiEndpoint={apiEndpoints.read}
                editRecord={handleEditRecord}
                addRecord={handleAddRecord}
                initialData={announcementsSearchState}
                rowDetails={rowDetails}
                refreshDatagrid={refreshDatagrid}
            />

            {showModal && (
                <AnnouncementsForm
                    isOpen={showModal}
                    onClose={handleModalClose}
                    title={modalTitle}
                    rowData={editRowData}
                    onRecordSubmit={handleRecordSubmit}
                />
            )}
        </>
    );
};

export default Announcements;
